import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {
  availableSeats,
  displayStatus,
  formatDate,
  formatTime
} from '../utils/booking';

const { FiArrowLeft, FiClock, FiUsers } = FiIcons;

export default function BookingTripChoices({
  date,
  sessions,
  reservations,
  adjustments,
  selectedSessionId,
  onSelect,
  onBack,
  onContinue,
  onWaitlist
}) {
  const selectedSession = sessions.find((item) => item.id === selectedSessionId);

  return (
    <section className="booking-choice-section">
      <button className="back-link" onClick={onBack}>
        <SafeIcon icon={FiArrowLeft} /> Change date
      </button>

      <div className="selected-date-heading">
        <span className="eyebrow">Selected fishing date</span>
        <h2>{formatDate(date, true)}</h2>
      </div>

      <div className="booking-trip-list">
        {sessions.map((session) => {
          const seats = availableSeats(session, reservations, adjustments);
          const status = displayStatus(session, reservations, adjustments);
          const selectable = status === 'OPEN' && seats > 0;
          const waitlistable = session.status === 'OPEN' && seats === 0;

          return (
            <div className="booking-trip-option-wrap" key={session.id}>
              <button
                className={`booking-trip-option ${selectedSessionId === session.id ? 'selected' : ''}`}
                disabled={!selectable}
                onClick={() => onSelect(session.id)}
              >
                <span className="trip-option-copy">
                  <strong>{session.tripType.name}</strong>
                  <small>{formatTime(session.start_time)} · {session.tripType.duration_hours} hours</small>
                </span>
                <span className="trip-option-seats">
                  <SafeIcon icon={FiUsers} />
                  {selectable ? `${seats} seats available` : status}
                </span>
              </button>

              {waitlistable && (
                <button
                  className="waitlist-button"
                  onClick={() => onWaitlist(session.id)}
                >
                  Join Waitlist
                </button>
              )}
            </div>
          );
        })}
      </div>

      {selectedSession && (
        <button className="button primary full" onClick={onContinue}>
          Continue to Party Size
        </button>
      )}

      <p className="choice-help">
        <SafeIcon icon={FiClock} /> Availability reflects the guide’s current seat inventory.
      </p>
    </section>
  );
}